"use client";

import { Amer25Schedule, Amer25PostSchedule } from "~/data/amer25-data";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";

const Schedule = () => {
  return (
    <div className="mb-0 bg-gradient-to-r from-blue-950 via-[#008793] to-[#A8EB12] pt-20 text-white">
      <h2 className="mb-12 px-6 text-center text-3xl">
        Outshift’s Cisco Live 2025 sessions - watch now!
      </h2>
      <div className="w-full bg-black/30 backdrop-blur-md">
        <div className="container py-6 pb-16">
          {Amer25PostSchedule.map((date, i) => (
            <div className="py-3" key={i}>
              <Table>
                <TableHeader className="border-b">
                  <TableRow className="border-0 border-b-0 text-lg ">
                    <TableHead className="w-3/12 px-0 pb-4 text-white">
                      Session Code
                    </TableHead>
                    <TableHead className="w-6/12 px-0 pb-4 text-white">
                      Session Title
                    </TableHead>
                    <TableHead className="w-3/12 px-0 pb-4 text-white">
                      Speaker
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody className="mt-12 pt-4">
                  {date.sessions.map((session, sid) =>
                    session.url ? (
                      <TableRow
                        className="cursor-pointer px-0 font-thin"
                        onClick={() =>
                          window?.open(
                            session.url,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                        key={sid}
                      >
                        <TableCell
                          className={`px-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.code}
                        </TableCell>
                        <TableCell
                          className={`pl-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.title}
                        </TableCell>
                        <TableCell
                          className={`px-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.speaker}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow key={sid} className="px-0 font-thin">
                        <TableCell
                          className={`px-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.code}
                        </TableCell>
                        <TableCell
                          className={`pl-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.title}
                        </TableCell>
                        <TableCell
                          className={`px-0 align-top text-base ${sid == 0 && "pt-4"}`}
                        >
                          {session.speaker}
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Schedule;
